import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface FormGroupErrorProps {
  children: React.ReactNode;
}

const ErrorComponent: React.FC<FormGroupErrorProps> = ({ children }) => {
  return <div className="peptalk-form-group-error">{children}</div>;
};

export const Error: React.FC<FormGroupErrorProps> = (
  props: FormGroupErrorProps
) => {
  const Component = useCustomComponent({
    componentName: 'FormGroupError',
    Component: ErrorComponent,
  });

  return <Component {...props} />;
};
